// 购物车
<template>
    <div class="list-container">
        <!-- 顶部导航栏 -->
        <div class="top-header">
            <div class="header-left" @click="goBack">
                <i class="el-icon-arrow-left"></i>
            </div>
            <div class="header-center">
                <h3>Shopping Cart</h3>
            </div>
            <div class="header-right">
                <!-- 占位，保持布局平衡 -->
            </div>
        </div>

        <!-- 结果列表区域 -->
        <div class="result-section">
            <div class="result-content">
                <!-- 证书号查询 -->
                <div class="filter-section cert-query-section">
                    <div class="cert-query-row">
                        <div class="filter-title">{{ $t('common.CertNo') }}：</div>
                        <el-input 
                            size="small"
                            v-model="query.cert_no" 
                            :placeholder="$t('common.pleaseInput')"
                            class="cert-input">
                        </el-input>
                    </div>
                </div>
                
                <!-- 查询按钮 -->
                <div class="filter-section action-buttons">
                    <el-button @click="resetForm('query')" class="reset-btn" size="small">{{ $t('button.reset') }}</el-button>
                    <el-button type="primary" @click="selectDiamondInfoList" class="search-btn" size="small">{{ $t('button.search') }}</el-button>
                </div>
                
                <!-- 操作按钮和统计信息 -->
                <div class="filter-section">
                    <div class="action-bar">
                        <el-button type="primary" @click="selectCertno" size="small" :disabled="isAble">{{ $t('button.getCertNo') }}</el-button>
                        <el-button type="success" @click="dialogTableVisible3 = true" size="small" :disabled="isAble">{{ $t('button.batchOrder') }}</el-button>
                        <el-button type="primary" @click="cancelShopInfo" size="small" :disabled="isAble">{{ $t('button.batchCancel') }}</el-button>
                    </div>
                    <div class="statistics-info">
                        <span>{{ $t('common.Selected') }}: {{data_len}}； {{ $t('common.TotalW') }}: {{ ct_total }}； {{ $t('common.TotalP') }}: ${{ sale_usd_total }}；</span>
                    </div>
                </div>
                
                <!-- 结果表格 -->
                <div class="filter-section table-section">
                    <!--分页-->
                    <div class="pagination-bar">
                        <el-pagination @size-change="sizeChange" @current-change="pageChange" :current-page="pager.page"
                                       :page-sizes="[10, 20, 50, 200]" :page-size="pager.rows"
                                       layout="total,sizes, prev, next"
                                       :total="pager.total"></el-pagination>
                    </div>
                    <div class="table-wrapper">
                        <el-table 
                            :data="diamondInfoList" 
                            stripe
                            @selection-change="selectionLineChangeHandle"
                            @row-click="handleRowClick"
                            ref="refTable" 
                            size="mini"
                            :header-cell-style="{background:'#f0f0f0',color:'#333',fontSize:'11px',padding:'3px 0',fontWeight:'bold'}" 
                            :row-style="{height:'20px',fontSize:'12px',padding:'0',margin:'0'}"
                            :class="['diamond-mobile-table', { 'safari-only': isSafari }]"
                            :height="tableHeight">
                            <el-table-column type="selection" align="left" width="35" :selectable="rowSelectable"></el-table-column>
                            
                            <el-table-column align="center" min-width="97%" :label="$t('common.Details')">
                                <template slot-scope="scope">
                                    <div style="font-size:12px;color:#666;font-weight:bold;display:flex;text-align:left">
                                        <div style="flex:1;text-align:left">
                                            <span>GIA {{ scope.row.cert_no }}</span>
                                        </div>
                                        <div style="flex:1;text-align:left;display:flex;align-items:center;gap:6px;flex-wrap:wrap">
                                            <span>{{ scope.row.place }} {{ scope.row.year }}</span>&nbsp;
                                            <div class="media-links" style="display:flex;align-items:center;gap:8px">
                                                <div v-if="scope.row.image_link" class="image-link">
                                                    <i class="el-icon-picture-outline" 
                                                       @click.stop="viewImage(scope.row.image_link)" 
                                                       title="View Diamond Image"></i>
                                                </div>&nbsp;
                                                <div v-if="scope.row.vedio_link" class="vedio_link">
                                                    <i class="el-icon-video-camera" 
                                                       @click.stop="viewVideo(scope.row.vedio_link)" 
                                                       title="View Diamond Video"></i>
                                                </div>&nbsp;
                                                <div v-if="scope.row.image_link_yuan" class="image_link_yuan">
                                                    <i class="el-icon-picture" 
                                                       @click.stop="viewImage(scope.row.image_link_yuan)" 
                                                       title="View Diamond Image"></i>
                                                </div>&nbsp;
                                                <div v-if="scope.row.vedio_link_yuan" class="vedio_link_yuan">
                                                    <i class="el-icon-video-camera" 
                                                       @click.stop="viewVideo(scope.row.vedio_link_yuan)" 
                                                       title="View Diamond Video"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="font-size:12px;color:#666;font-weight:bold;display:flex;text-align:left">
                                        <div style="flex:1;text-align:left">
                                            <span v-if="scope.row.shape === '圆形'">{{ $t('common.Round') }}</span>
                                            <span v-else-if="scope.row.shape === '公主方'">{{ $t('common.Princess') }}</span>
                                            <span v-else-if="scope.row.shape === '雷迪恩'">{{ $t('common.Radiant') }}</span>
                                            <span v-else-if="scope.row.shape === '阿斯切'">{{ $t('common.Asscher') }}</span>
                                            <span v-else-if="scope.row.shape === '马眼' || scope.row.shape === '马眼形'">{{ $t('common.Marquise') }}</span>
                                            <span v-else-if="scope.row.shape === '椭圆' || scope.row.shape === '椭圆形'">{{ $t('common.Oval') }}</span>
                                            <span v-else-if="scope.row.shape === '祖母绿'">{{ $t('common.Emerald') }}</span>
                                            <span v-else-if="scope.row.shape === '梨形'">{{ $t('common.Pear') }}</span>
                                            <span v-else-if="scope.row.shape === '心形'">{{ $t('common.Heart') }}</span>
                                            <span v-else-if="scope.row.shape === '垫形'">{{ $t('common.Cushion') }}</span>
                                            <span v-else-if="scope.row.shape === '其他'">{{ $t('common.Others') }}</span>
                                            <span v-else-if="scope.row.shape === '三角形'">{{ $t('common.Triangle') }}</span>
                                            <span v-else>{{ scope.row.shape }}</span>
                                            {{ scope.row.ct }}ct 
                                            
                                        </div>
                                        <div style="flex:1;text-align:left">
                                            {{ scope.row.col }} {{ scope.row.cla }}
                                            {{ scope.row.cut }} {{ scope.row.pol }} {{ scope.row.sym }} {{ scope.row.fl }}
                                        </div>
                                    </div>
                                    <div style="font-size:12px;color:#666;font-weight:bold;display:flex;text-align:left">
                                        <div style="flex:1;text-align:left">
                                            <div style="flex:1;text-align:left">{{ scope.row.meas}}mm</div>
                                        </div>
                                        <div style="flex:1;text-align:left">
                                            <span v-if="scope.row.table1">Table:{{ scope.row.table1 }}</span>&nbsp;&nbsp;
                                            <span v-if="scope.row.depth">Depth:{{ scope.row.depth }}</span>
                                        </div>
                                    </div>
                                    <div style="font-size:12px;color:#666;font-weight:bold;display:flex;text-align:left">
                                        <div style="flex:1;text-align:left">
                                            {{ scope.row.sale_rap }}
                                            &nbsp;
                                            <span style="color:#0066ff;font-weight:bold">{{ scope.row.new_dis }}%</span>
                                            &nbsp;&nbsp;
                                            <span style="color:red;font-weight:bold">${{ scope.row.sale_usd }}</span>
                                        </div>
                                        <div style="flex:1;text-align:left">
                                            <span style="color:#0066ff;font-weight:bold">{{ scope.row.rating }}</span>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                            
                            <!-- 重量列 
                            <el-table-column align="center" min-width="5%">
                                <template slot-scope="scope">
                                    <div class="media-links">
                                        <div v-if="scope.row.image_link" class="image-link">
                                            <i class="el-icon-picture-outline" 
                                               @click.stop="viewImage(scope.row.image_link)" 
                                               title="View Diamond Image"></i>
                                        </div>
                                        <div v-if="scope.row.vedio_link" class="vedio_link">
                                            <i class="el-icon-video-camera" 
                                               @click.stop="viewVideo(scope.row.vedio_link)" 
                                               title="View Diamond Video"></i>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                            -->
                            <!-- 规格列 
                            <el-table-column align="center" min-width="47%" :label="$t('common.Details')">
                                <template slot-scope="scope">
                                    <div style="font-weight:bold">
                                        {{ scope.row.cert_no }}
                                        <span v-if="scope.row.shape === '圆形'">{{ $t('common.Round') }}</span>
                                        <span v-else-if="scope.row.shape === '公主方'">{{ $t('common.Princess') }}</span>
                                        <span v-else-if="scope.row.shape === '雷迪恩'">{{ $t('common.Radiant') }}</span>
                                        <span v-else-if="scope.row.shape === '阿斯切'">{{ $t('common.Asscher') }}</span>
                                        <span v-else-if="scope.row.shape === '马眼' || scope.row.shape === '马眼形'">{{ $t('common.Marquise') }}</span>
                                        <span v-else-if="scope.row.shape === '椭圆' || scope.row.shape === '椭圆形'">{{ $t('common.Oval') }}</span>
                                        <span v-else-if="scope.row.shape === '祖母绿'">{{ $t('common.Emerald') }}</span>
                                        <span v-else-if="scope.row.shape === '梨形'">{{ $t('common.Pear') }}</span>
                                        <span v-else-if="scope.row.shape === '心形'">{{ $t('common.Heart') }}</span>
                                        <span v-else-if="scope.row.shape === '垫形'">{{ $t('common.Cushion') }}</span>
                                        <span v-else-if="scope.row.shape === '其他'">{{ $t('common.Others') }}</span>
                                        <span v-else-if="scope.row.shape === '三角形'">{{ $t('common.Triangle') }}</span>
                                        <span v-else>{{ scope.row.shape }}</span>
                                        
                                    </div>
                                    <div style="font-size:11px;color:#666;font-weight:bold">
                                        {{ scope.row.ct }}ct 
                                        {{ scope.row.col }}  {{ scope.row.cla }}
                                        {{ scope.row.cut }} {{ scope.row.pol }} {{ scope.row.sym }} {{ scope.row.fl }}
                                    </div>
                                    <div style="font-size:11px;color:#666;font-weight:bold">
                                        {{ scope.row.meas}} {{ scope.row.table1 }}  {{ scope.row.depth }} {{ scope.row.year }}
                                    </div>
                                </template>
                            </el-table-column>
                            -->
                            <!-- 折扣列 
                            <el-table-column align="center" min-width="20%" :label="$t('common.Price')">
                                <template slot-scope="scope">
                                    <div style="color:goldenrod;">{{ scope.row.sale_rap }}</div>
                                    <div style="color:#0066ff;font-weight:bold">{{ scope.row.new_dis }}%</div>
                                    <div style="color:fuchsia;font-weight:bold">{{ scope.row.sale_usd }}</div>
                                    
                                    <div style="color:fuchsia;font-weight:bold" v-if="scope.row.place === 'HK' || scope.row.place === 'H-K'">
                                        ${{ scope.row.sale_usd }}
                                    </div>
                                    <div style="color:fuchsia;font-weight:bold" v-else>
                                        ￥{{ scope.row.sale_price }}
                                    </div>
                                    
                                </template>
                            </el-table-column>
                            -->
                            <!-- 来源和价格列
                            <el-table-column align="center" min-width="28%" :label="$t('common.Remark')">
                                <template slot-scope="scope">
                                    <div style="color:#666;font-size:11px;font-weight:bold">{{ scope.row.place}}</div>
                                    <div style="color:#666;font-size:11px;font-weight:bold;white-space:normal;word-wrap:break-word;word-break:break-all;line-height:1.4;">{{ scope.row.rating}}</div>
                                </template>
                            </el-table-column>
                             -->
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- 对话框 -->
        <div class="text e-info auto-table">
            <el-dialog :title="$t('common.Order')" :visible.sync = "dialogTableVisible3" @close="closeSava" 
                width="150px" center :close-on-click-modal="false" :append-to-body="true">
                <el-form :inline="true" label-width="150px" size="small" 
                    :model="addDataForm3" class="demo-form-inline" ref="addDataForm3" :rules="rules3">
                    <el-form-item prop="vipCount" :label="$t('common.Customer') + ':'" style="width: 100%;float:left">
                        <el-input v-model="addDataForm3.vipCount" :placeholder="$t('common.pleaseInput')"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="savaAllOrderInfo">{{ $t('button.confirm') }}</el-button>
                </div>
            </el-dialog>
            <el-dialog title="批量删除" :visible.sync = "dialogTableVisible8" @close="closeSava" 
                width="600px" center :close-on-click-modal="false">
                <span>是否确认进行批量删除操作</span>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="dialogTableVisible8 = false">取消</el-button>
                    <el-button type="primary" @click="deleteShoppingInfo">确认</el-button>
                </div>
            </el-dialog>
        </div>
        <el-dialog
          title="Image"
          :visible.sync="imageDialogVisible"
          width="90%"
          center
          append-to-body
          :close-on-click-modal="true"
          :before-close="handleImageDialogClose">
          <div class="image-dialog-content">
            <img :src="currentImageUrl" alt="Image" class="diamond-image">
          </div>
        </el-dialog>
        
        <el-dialog
          title="Video"
          :visible.sync="videoDialogVisible"
          width="90%"
          center
          append-to-body
          :close-on-click-modal="true"
          :before-close="handleVideoDialogClose">
          <div class="video-dialog-content">
            <video 
              :src="currentVideoUrl" 
              class="diamond-video" 
              controls 
              autoplay
              controlsList="nodownload">
              Your browser does not support the video playback
            </video>
          </div>
        </el-dialog>
    </div>
</template>
<script>
    import util from '../../common/js/util';
    const cityOptions = ['D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M-N', 'O-Z'];
    export default {
        data() {
            return {
                tableHeight: 400, // 表格高度，会在mounted时动态计算
                isSafari: false, // 是否为 Safari 浏览器
                isExpand: true,
                isAble: true,
                dialogTableVisible8: false,
                dialogTableVisible3: false,
                checkboxGroup1: [],
                checkboxGroup2: [],
                checkboxGroup3: [],
                checkboxGroup4: [],
                checkboxGroup5: [],
                checkboxGroup6: [],
                checkboxGroup7: [],
                checkboxGroup8: [],
                checkboxGroup9: [],
                checkboxGroup10: [],
                checkboxGroup11: [],
                shapeList: [{'value':'Round'},{'value':'Princess'},{'value':'Radiant'}
                            ,{'value':'Asscher'},{'value':'Marquise'},{'value':'Oval'}
                            ,{'value':'Emerald'},{'value':'Pear'},{'value':'Heart'}
                            ,{'value':'Cushion'},{'value':'Others'},{'value':'Triangle'}],
                shapeList1: [{'value':'圆形'},{'value':'公主方'},{'value':'雷迪恩'}
                            ,{'value':'阿斯切'},{'value':'马眼'},{'value':'椭圆形'}
                            ,{'value':'祖母绿'},{'value':'梨形'},{'value':'心形'}
                            ,{'value':'垫形'},{'value':'其他'},{'value':'三角形'}],
                colList: [{'value':'D'},{'value':'E'},{'value':'F'}
                            ,{'value':'G'},{'value':'H'},{'value':'I'}
                            ,{'value':'J'},{'value':'K'},{'value':'L'}
                            ,{'value':'M-N'},{'value':'O-Z'}],
                claList: [{'value':'FL'},{'value':'IF'},{'value':'VVS1'}
                            ,{'value':'VVS2'},{'value':'VS1'},{'value':'VS2'}
                            ,{'value':'SI1'},{'value':'SI2'},{'value':'SI3'}
                            ,{'value':'I1'},{'value':'I2'}],
                cutList: [{'value':'EX'},{'value':'VG'},{'value':'GD'}
                            ,{'value':'FR'},{'value':'PR'},{'value':'NN'}],
                polList: [{'value':'EX'},{'value':'VG'},{'value':'GD'}
                            ,{'value':'FR'},{'value':'PR'}],
                flList: [{'value':'N'},{'value':'VSL'},{'value':'F'}
                            ,{'value':'M'},{'value':'S'},{'value':'VS'}],
                placeList: [{'value':'HK'},{'value':'CHINA'},{'value':'SZ'}
                            ,{'value':'INDIA'},{'value':'LAB'},{'value':'SH'},{'value':'H-K'}],
                certList: [{'value':'GIA'},{'value':'NGTC'},{'value':'IGI'}
                            ,{'value':'HRD'},{'value':'None'},{'value':'Other'}],
                inv_statusList: [{'value':'在库'},{'value':'不在库'}],
                sale_statusList: [{'value':'在售'},{'value':'保留'},{'value':'借货'}
                            ,{'value':'全款借货'},{'value':'确认销售'},{'value':'已完成'}],
                colorlist: cityOptions,
                clalist: ['FL', 'IF', 'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2', 'SI3','I1','I2'],
                cutlist: ['EX', 'VG', 'GD', 'FR', 'PR', 'NN'],
                pollist: ['EX', 'VG', 'GD', 'FR', 'PR'],
                fllist: ['N', 'VSL', 'F', 'M', 'S', 'VS'],
                certlist: ['GIA', 'NGTC', 'IGI', 'HRD', 'None', 'Other'],
                status: '',
                isq: '',
                inv_status: '',
                dateList: {},
                baojiaform: {},
                addDataForm: {},
                addDataForm2: {},
                addDataForm3: {
                    'sale_status': '1',
                    'tiaodian1': '1',
                    'date_long': '24h',
                    'vipCount': sessionStorage.getItem('userName')
                },
                addDataForm4: {},
                addDataForm5: {},
                addDataForm6: {},
                dataOnLineListSelections: [],
                certnoList: [],
                certnoStr: '',
                sale_priceList: [],
                sale_priceStr: '',
                idList: [],
                idStr: '',
                diamondInfoList: [],
                diamondAllInfoList: {},
                ct_total: 0,
                data_len: 0,
                sale_rap_total: 0,
                sale_usd_total: 0,
                sale_price_total: 0,
                ratevalue: '',
                // 查询
                query: {
                    data_dt: [],
                    ct1: '',
                    ct2: '',
                },
                imageDialogVisible: false,
                currentImageUrl: '',
                videoDialogVisible: false,
                currentVideoUrl: '',
                queryDate: '',
                // queryDate: this.getNowTime(),
                // 分页
                pager: {
                    page: 1,
                    rows: 20,
                    total: 0
                },
                rules3:{
                    vipCount:[
                        {
                            required:true,
                            message:'Please input customer!',
                            trigger:'blur'
                        }
                    ]
                },
            };
        },
        methods: {
            // 返回
            goBack() {
                this.$router.push('/index');
            },
            // 选择行数
            sizeChange(rows) {
                this.pager.rows = rows;
                this.selectDiamondInfoList();
            },
            // 选择页
            pageChange(page) {
                this.pager.page = page;
                this.selectDiamondInfoList();
            },
            // shape 形状
            checkboxChange1(val) {
                this.query.shape = val.join();
                console.log(this.query.shape);
            },
            // 颜色
            checkboxChange2(val) {
                this.query.col = val.join();
                console.log(this.query.col);
            },
            // 净度
            checkboxChange3(val) {
                this.query.cla = val.join();
                console.log(this.query.col);
            },
            // 切工
            checkboxChange4(val) {
                this.query.cut = val.join();
                console.log(this.query.cut);
            },
            // 抛光
            checkboxChange5(val) {
                this.query.pol = val.join();
                console.log(this.query.pol);
            },
            // 对称
            checkboxChange6(val) {
                this.query.sym = val.join();
                console.log(this.query.sym);
            },
            // 荧光
            checkboxChange7(val) {
                this.query.fl = val.join();
                console.log(this.query.fl);
            },
            // 证书
            checkboxChange8(val) {
                this.query.cert = val.join();
                console.log(this.query.cert);
            },
            // 联动赋值重量
            ctChange(val) {
                if(val == 3) {
                    this.$set(this.query,'ct1','0.30');
                    this.$set(this.query,'ct2','0.39');
                }else if(val == 4) {
                    this.$set(this.query,'ct1','0.40');
                    this.$set(this.query,'ct2','0.49');
                }else if(val == 5) {
                    this.$set(this.query,'ct1','0.50');
                    this.$set(this.query,'ct2','0.69');
                }else if(val == 7) {
                    this.$set(this.query,'ct1','0.70');
                    this.$set(this.query,'ct2','0.89');
                }else if(val == 10) {
                    this.$set(this.query,'ct1','1.00');
                    this.$set(this.query,'ct2','1.49');
                }else if(val == 15) {
                    this.$set(this.query,'ct1','1.50');
                    this.$set(this.query,'ct2','1.99');
                }
            },
            // 手动输入重量
            ctSelect(e) {
                let value = e.target.value;
                if(value) {
                    console.log(value)
                    if(value.includes('-')){
                        this.$nextTick(()=> {
                            this.$set(this.query,'ct',value);
                        })
                        // this.query.ct = value;
                        let valArr = value.split('-');
                        this.$set(this.query,'ct1',valArr[0]);
                        this.$set(this.query,'ct2',valArr[1]);
                        console.log(this.query.ct1);
                        console.log(this.query.ct2);
                    }
                }
            },
            // 3EXN
            select3exn() {
                this.checkboxGroup4 = ['EX'];
                this.checkboxGroup5 = ['EX'];
                this.checkboxGroup6 = ['EX'];
                this.checkboxGroup7 = ['N'];
                this.query.cut = 'EX';
                this.query.pol = 'EX';
                this.query.sym = 'EX';
                this.query.fl = 'N';
            },
            // EXN
            selectexn() {
                this.checkboxGroup4 = ['EX'];
                this.checkboxGroup5 = ['EX','VG'];
                this.checkboxGroup6 = ['EX','VG'];
                this.checkboxGroup7 = ['N'];
                this.query.cut = 'EX';
                this.query.pol = 'EX,VG';
                this.query.sym = 'EX,VG';
                this.query.fl = 'N';
            },
            // VGN
            selectvgn() {
                this.checkboxGroup4 = ['VG'];
                this.checkboxGroup5 = ['EX','VG'];
                this.checkboxGroup6 = ['EX','VG'];
                this.checkboxGroup7 = ['N'];
                this.query.cut = 'VG';
                this.query.pol = 'EX,VG';
                this.query.sym = 'EX,VG';
                this.query.fl = 'N';
            },
            // 选择器选择数据，加工数据证书号、统计数据
            selectionLineChangeHandle(val) {
                // 统计选中数量
                this.data_len = val.length;
                // 计算总销售额
                let sale_rap1 = 0;
                let sale_usd1 = 0;
                let sale_price1 = 0;
                let ct1 = 0;
                for(let a = 0; a < this.data_len; a++) {
                    console.log(val[0].sale_price);
                    console.log(val[0].ct);
                    // rap
                    sale_rap1 += val[a].sale_rap;
                    // 销售价格
                    sale_usd1 += val[a].sale_usd;
                    sale_price1 += val[a].sale_price;
                    // 重量
                    ct1 += parseFloat(val[a].ct);
                }
                // rap
                this.sale_rap_total = sale_rap1.toFixed(2);
                // 销售价格
                this.sale_usd_total = sale_usd1.toFixed(2);
                this.sale_price_total = sale_price1.toFixed(2);
                // 总重量
                this.ct_total = ct1.toFixed(2);
                // 选中导出数据赋值
                this.dataOnLineListSelections = val;
                // id、数据证书号拼接
                this.idList = val.map((item) => item.id);
                this.certnoList = val.map((item) => item.cert_no + '\n');
                this.sale_priceList = val.map((item) => item.sale_price);
                //数据选中后，显示按钮
                if(this.certnoList.length>0) {
                    this.isAble = false;
                }else{
                    this.isAble = true;
                }
            },
            // 获取证书号
            selectCertno() {
                this.certnoStr = this.certnoList.join(',');
                this.certnoStr = this.certnoStr.replaceAll(',','');
                console.log(this.certnoStr)
                // 复制
                this.copyText(this.certnoStr);
            },
            copyText(val){
                // 存储传递过来的数据
                //let userId = sessionStorage.getItem("userId");
                // createElement() 方法通过指定名称创建一个元素
                let newInput = document.createElement('textarea');
                // 讲存储的数据赋值给input的value值
                newInput.value = val;
                // appendChild() 方法向节点添加最后一个子节点
                document.body.appendChild(newInput);
                // select() 方法用于选择该元素中的文本
                newInput.select();
                // execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
                document.execCommand('Copy');
                // 清空输入框
                newInput.remove();
                // 下面是element的弹窗 不需要的自行删除就好
                this.$message({
                    message: "Success!",
                    type: "success",
                });
            },
            // 客户批量下单
            savaAllOrderInfo() {
                let _this = this;
                let idStr = _this.idList.join(',');
                let cert_noStr = _this.certnoList.join(',').replaceAll('\n','');
                util.publicget('/shoppingHK/savaOrderInfo', {
                    user: sessionStorage.getItem('userName'),
                    token: sessionStorage.getItem('token_time'),
                    sign: 'cart',
                    id: idStr,
                    cert_no: cert_noStr
                }, function (res) {
                    if (res.flag) {
                        console.log(res);
                        _this.successMsg("Success!");
                        _this.dialogTableVisible3 = false;
                        _this.selectDiamondInfoList();
                    } else {
                        _this.errorMsg("Failed!");
                    }
                })
            },
            /*
            // 客户下单
            savaOrderInfo(rows) {
                let _this = this;
                //_this.idStr = _this.idList.join(',');
                //_this.cert_no = _this.certnoList.join(',').replaceAll('\n','');
                //_this.sale_priceStr = _this.sale_priceList.join(',');
                util.publicget('/shopping/savaOrderInfo', {
                    // user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName'),
                    id: rows.id,
                    cert_no: rows.cert_no,
                    sale_priceStr: rows.sale_price
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        _this.successMsg("Success!");
                        _this.selectDiamondInfoList();
                    } else {
                        _this.errorMsg("Failed!");
                    }
                })
            },
            */
            // 取消订单
            deleteShoppingInfo(rows) {
                let _this = this;
                //_this.idStr = _this.idList.join(',');
                util.publicget('/shopping/deleteShoppingInfo', {
                    // user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName'),
                    token: sessionStorage.getItem('token_time'),
                    id: rows.id,
                    cert_no: rows.cert_no
                }, function (res) {
                    if (res.flag) {
                        _this.successMsg("Success!");
                        _this.selectDiamondInfoList();
                    } else {
                        _this.errorMsg("Failed!");
                    }
                });
            },
            
            // 从购物车中删除
            cancelShopInfo() {
                let _this = this;
                let idStr = _this.idList.join(',');
                let cert_noStr = _this.certnoList.join(',').replaceAll('\n','');
                util.publicget('/shoppingHK/cancelInfo2', {
                    // user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName'),
                    token: sessionStorage.getItem('token_time'),
                    id: idStr,
                    cert_no: cert_noStr
                }, function (res) {
                    if (res.flag) {
                        _this.successMsg("Success!");
                        _this.selectDiamondInfoList();
                    } else {
                        _this.errorMsg("Failed!");
                    }
                });
            },
            // 取消选购
            /*cancelInfo(rows) {
                let _this = this;
                util.publicget('/shopping/cancelInfo', {
                    user: document.cookie.split(';')[1].split('=')[1],
                    id: rows.id,
                    cert_no: rows.cert_no
                }, function (res) {
                    if (res.flag) {
                        _this.successMsg(res.msg);
                        _this.selectDiamondInfoList();
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },*/
            // dialog 关闭，数据清空
            closeSava() {
                this.selectDiamondInfoList();
            },
            // 前端处理 选中数据导出
            exportSelect() {
                //let res =[{name:'小白',age:'18'},{name:'小黑',age:'16'}]
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../../common/js/Export2Excel.js')
                    const tHeader = ['CertNo','Place', 'Status', 'Shape', 'Weight', 'Color'
                            , 'Clarity', 'Cut', 'Polish', 'Symmetry', 'Fluorescence', 'Certificate'
                            , 'Sale Rap', 'Sale Discount', 'Sale USD', 'Sale Price'
                            , 'Size', 'Table', 'Depth', 'Ratio']
                    const filterVal = ['cert_no', 'place', 'sale_status', 'shape', 'ct', 'col'
                            ,'cla', 'cut', 'pol', 'sym', 'fl', 'cert'
                            ,'sale_rap', 'new_dis', 'sale_usd' , 'sale_price' 
                            ,'meas', 'table1', 'depth', 'ratio']
                    const list = this.dataOnLineListSelections
                    const data = this.formatJson(filterVal, list)
                    export_json_to_excel(tHeader, data, 'CartInformation')
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            exportAll() {
                //let res =[{name:'小白',age:'18'},{name:'小黑',age:'16'}]
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../../common/js/Export2Excel.js')
                    const tHeader = ['CertNo','Place', 'Status', 'Shape', 'Weight', 'Color'
                            , 'Clarity', 'Cut', 'Polish', 'Symmetry', 'Fluorescence', 'Certificate'
                            , 'Sale Rap', 'Sale Discount', 'Sale USD', 'Sale Price'
                            , 'Size', 'Table', 'Depth', 'Ratio']
                    const filterVal = ['cert_no', 'place', 'sale_status', 'shape', 'ct', 'col'
                            ,'cla', 'cut', 'pol', 'sym', 'fl', 'cert'
                            ,'sale_rap', 'new_dis', 'sale_usd' , 'sale_price' 
                            ,'meas', 'table1', 'depth', 'ratio']
                    const list = this.diamondAllInfoList
                    const data = this.formatJson(filterVal, list)
                    export_json_to_excel(tHeader, data, 'CartInformation')
                })
            },
            // 查询全部数据用于导出
            selectAllList() {
                let _this = this;
                util.publicget('/shoppingHK/queryDaimondShopListByCondition', {
                }, function (res) {
                    if (res.flag) {
                        console.log(res.obj);
                        if(res.obj.length>0) {
                            _this.diamondAllInfoList = res.obj;
                            _this.exportAll();
                        }else {
                            _this.errorMsg("Failed!");
                        }
                    } else {
                        _this.errorMsg("Failed!");
                    }
                });
            },
            // 加载分页数据信息
            selectDiamondInfoList() {
                let _this = this;
                util.publicget('/shoppingHK/queryDaimondShoppingList', {
                    user: sessionStorage.getItem('userName'),
                    token: sessionStorage.getItem('token_time'),
                    // user: document.cookie.split(';')[1].split('=')[1],
                    shape: _this.query.shape,
                    col: _this.query.col,
                    cla: _this.query.cla,
                    cut: _this.query.cut,
                    pol: _this.query.pol,
                    sym: _this.query.sym,
                    fl: _this.query.fl,
                    place: _this.query.place,
                    cert: _this.query.cert,
                    cert_no: _this.query.cert_no,
                    sale_status: _this.query.sale_status,
                    inv_status: _this.query.inv_status,
                    equalsSupplier: _this.query.supplier,
                    greaterEqualsCt: _this.query.ct1,
                    lessCt: _this.query.ct2,
                    pageNo: _this.pager.page,
                    pageSize: _this.pager.rows
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        _this.pager.total = res.count || 0;
                        _this.diamondInfoList = res.obj;
                        _this.certnoList = res.obj.map((item) => item.cert_no + '\n');
                        _this.idList = res.obj.map((item) => item.id);
                    } else {
                        _this.errorMsg('Failed!');
                        _this.$router.push({path: '/login'});
                    }
                });
            },
            /*
            // 查询数据字典 地点
            selectPlaceDictList() {
                let _this = this;
                util.publicget('/diamond/queryDaimondDictList', {
                    equalsParam: '地点'
                }, function (res) {
                    if (res.flag) {
                        console.log(res.obj);
                        _this.placeList = res.obj;
                    } else {
                        _this.errorMsg("Failed!");
                    }
                });
            },
            */
            // 取消
            resetForm(formName) {
                // 重置查询对象
                this.query = {
                    data_dt: [],
                    ct: '',
                    ct1: '',
                    ct2: '',
                    ct3: '',
                    ct4: '',
                    shape: '',
                    col: '',
                    cla: '',
                    cut: '',
                    pol: '',
                    sym: '',
                    fl: '',
                    cert: '',
                    place: '',
                    cert_no: '',
                    addPoint: 0,
                    milkCoffeeGreen: '',
                    noBlack: false,
                    cleanEye: false,
                    hasImage: false,
                    inStock: false,
                    isClosed: false,
                    hasSpecialPrice: false,
                    supplier: '',
                    stockNumber: ''
                };
                
                // 如果表单引用存在，也调用el-form的resetFields方法
                if (this.$refs[formName]) {
                    this.$refs[formName].resetFields();
                }
                
                // 强制更新视图
                this.$forceUpdate();
            },
            // 时间格式化
            formatterDate(row, column) {
                return util.formatDate.format(new Date(row.start_date), 'yyyy-MM-dd');
            },
            getNowTime() {
                var now = new Date();
                var year = now.getFullYear();
                var month = now.getMonth();
                var date = now.getDate();
                month = month + 1;
                month = month.toString().padStart(2, '0');
                date = date.toString().padStart(2, '0');
                var defaultDate = `${year}-${month}-${date}`;
                return defaultDate;
            },
            // 根据rmb排序
            sortTableFun (column) {
                this.column = column.prop;
                if (column.prop) {
                    if (column.order == 'ascending') {
                        this.order = 'asc'
                    }else if (column.order == 'descending') {
                        this.order = 'desc'
                    }
                    this.selectDiamondInfoList();
                }
            },
            renderHeader (h, {column, $index }) {
                if (column.order == 'ascending') {
                    return h(
                        'div',
                        [
                            h('span',column.label),
                            h('i',{
                                class:'el-icon-sort-up'
                            })
                        ]
                    )
                }else if (column.order == 'descending') {
                    return h(
                        'div',
                        [
                            h('span',column.label),
                            h('i',{
                                class:'el-icon-sort-down'
                            })
                        ]
                    )
                } else {
                    return h(
                        'div',
                        [
                            h('span',column.label),
                            h('i',{
                                class:'el-icon-sort'
                            })
                        ]
                    )
                }
            },
            handleRowClick(row, column, event) {
                // 如果点击的是展开按钮列或选择框列，不触发选择
                if (column.type === 'expand' || column.type === 'selection') {
                    return;
                }
                
                // 切换当前行的选中状态
                this.$refs.refTable.toggleRowSelection(row);
            },
            viewImage(imageUrl) {
                if (!imageUrl) return;
                
                // 设置当前图片URL
                if (imageUrl.startsWith('http')) {
                    this.currentImageUrl = imageUrl;
                } else {
                    // 如果不是完整URL，可能需要添加域名前缀
                    this.currentImageUrl = 'https://您的域名/' + imageUrl;
                }
                
                // 显示对话框
                this.imageDialogVisible = true;
            },
            rowSelectable(row) {
                // 让所有行都可以被选中，但仅通过点击勾选框
                return true;
            },
            handleImageDialogClose() {
                this.imageDialogVisible = false;
                this.currentImageUrl = '';
            },
            viewVideo(videoUrl) {
                if (!videoUrl) return;
                
                // 设置当前视频URL
                if (videoUrl.startsWith('http')) {
                    this.currentVideoUrl = videoUrl;
                } else {
                    // 如果不是完整URL，可能需要添加域名前缀
                    this.currentVideoUrl = 'https://您的域名/' + videoUrl;
                }
                
                // 显示对话框
                this.videoDialogVisible = true;
            },
            handleVideoDialogClose() {
                this.videoDialogVisible = false;
                this.currentVideoUrl = '';
                
                // 停止视频播放
                const videoElement = document.querySelector('.diamond-video');
                if (videoElement) {
                    videoElement.pause();
                    videoElement.currentTime = 0;
                }
            },
            // 计算表格高度
            calculateTableHeight() {
                this.$nextTick(() => {
                    const windowHeight = window.innerHeight;
                    const headerHeight = 50; // 顶部导航栏高度
                    const resultContentPadding = 24; // result-content 的上下padding
                    const certInputHeight = 80; // 证书号查询区域高度（估算）
                    const actionButtonsHeight = 60; // 查询按钮区域高度（估算）
                    const actionBarHeight = 80; // 操作按钮区域高度（估算）
                    const statisticsHeight = 40; // 统计信息高度（估算）
                    const paginationHeight = 50; // 分页高度（估算）
                    const tableSectionPadding = 24; // table-section 的上下padding
                    
                    // 计算剩余高度
                    const remainingHeight = windowHeight - headerHeight - resultContentPadding 
                                          - certInputHeight - actionButtonsHeight - actionBarHeight 
                                          - statisticsHeight - paginationHeight - tableSectionPadding;
                    
                    // 设置表格高度，最小200px
                    this.tableHeight = Math.max(remainingHeight, 200);
                });
            }
        },
        mounted() {
            this.selectDiamondInfoList();
            //this.selectPlaceDictList();
            
            // 计算表格高度
            this.$nextTick(() => {
                this.calculateTableHeight();
            });
            
            // 检测 Safari 浏览器
            this.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            
            // 监听窗口大小变化
            window.addEventListener('resize', this.calculateTableHeight);
        },
        beforeDestroy() {
            // 移除窗口大小变化监听
            window.removeEventListener('resize', this.calculateTableHeight);
        }
    };
</script>

<style lang="scss" scoped>
    .list-container {
        width: 100%;
        height: 100vh;
        background-color: #fff;
        position: relative;
        overflow: hidden;
    }

    .top-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 50px;
        background-color: #409EFF;
        padding: 0 15px;
        position: sticky;
        top: 0;
        z-index: 100;

        .header-left,
        .header-right {
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            color: #fff;
            font-size: 20px;
            transition: opacity 0.3s;

            &:active {
                opacity: 0.7;
            }
        }

        .header-center {
            flex: 1;
            text-align: center;

            h3 {
                margin: 0;
                color: #fff;
                font-size: 18px;
                font-weight: 500;
            }
        }
    }

    .result-section {
        padding: 0px;
        background-color: #f5f5f5;
        height: calc(100vh - 50px);
        position: relative;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        
        .result-content {
            flex: 1;
            overflow-y: auto;
            overflow-x: hidden;
            padding: 12px;
            -webkit-overflow-scrolling: touch;
            display: flex;
            flex-direction: column;
            min-height: 0;
            
            /* 自定义滚动条样式 */
            &::-webkit-scrollbar {
                width: 6px;
            }
            
            &::-webkit-scrollbar-thumb {
                background-color: #c0c4cc;
                border-radius: 3px;
                
                &:hover {
                    background-color: #a0a4a8;
                }
            }
            
            &::-webkit-scrollbar-track {
                background-color: #f5f5f5;
                border-radius: 3px;
            }
        }
    }

    .filter-section {
        margin-bottom: 5px;
        background-color: white;
        border-radius: 8px;
        padding: 12px 15px;
        box-shadow: 0 1px 2px rgba(0,0,0,0.08);
        
        &.cert-query-section {
            margin-bottom: 5px; // 证书号查询区域与按钮之间的间距，与其他区域保持一致
            
            .cert-query-row {
                display: flex;
                align-items: center;
                gap: 12px;
                
                .filter-title {
                    margin-bottom: 0;
                    white-space: nowrap;
                    flex-shrink: 0;
                }
                
                .cert-input {
                    flex: 1;
                }
            }
        }
        
        &.table-section {
            flex: 1;
            display: flex;
            flex-direction: column;
            min-height: 0;
            overflow: hidden;
            
            .pagination-bar {
                margin-bottom: 12px;
                flex-shrink: 0;
            }
            
            .table-wrapper {
                flex: 1;
                overflow: hidden;
                min-height: 0;
                display: flex;
                flex-direction: column;
                
                .diamond-mobile-table {
                    flex: 1;
                    min-height: 0;
                    display: flex;
                    flex-direction: column;
                    
                    /deep/ .el-table__body-wrapper {
                        flex: 1;
                        overflow-y: auto;
                    }

                    &.safari-only {
                        margin-bottom: 100px;
                    }
                }
            }
        }
    }

    .filter-title {
        font-size: 15px;
        font-weight: 600;
        margin-bottom: 12px;
        color: #333;
        border-bottom: none;
        padding-bottom: 0;
    }

    .cert-input {
        width: 100%;
        
        /deep/ .el-input__inner {
            border-radius: 6px;
            border: 1px solid #e0e0e0;
            padding: 10px 12px;
            font-size: 14px;
            
            &:focus {
                border-color: #409EFF;
            }
        }
    }

    .action-buttons {
        position: relative;
        background: white;
        margin-top: 0px;
        padding: 12px 15px;
        border-top: 1px solid #eee;
        box-shadow: 0 -2px 8px rgba(0,0,0,0.1);
        flex-shrink: 0;
        display: flex;
        gap: 10px;
    }

    .search-btn, .reset-btn {
        flex: 1;
        height: 32px;
        font-size: 14px;
        border-radius: 4px;
    }

    .search-btn {
        background-color: #409EFF;
        border-color: #409EFF;
    }

    .action-bar {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin-bottom: 12px;
        
        .el-button {
            flex: 1;
            min-width: 80px;
        }
    }

    .statistics-info {
        font-size: 14px;
        color: #333;
        padding-top: 8px;
        border-top: 1px solid #eee;
    }

    /**手机屏幕展示 */
    @media screen and (max-width: 748px){
        /* 钻石表格专用样式 */
        .diamond-table {
            border: 1px solid #ddd !important;
            table-layout: fixed !important; /* 确保表格布局固定，列宽均等 */
            
            /* 内容列均分样式 */
            .el-table__body-wrapper .el-table__body td:not(.el-table-column--selection):not(.hidden-expand-column) {
                width: 25% !important;
            }
            
            /* 表头均分样式 */
            .el-table__header-wrapper .el-table__header th:not(.el-table-column--selection):not(.hidden-expand-column) {
                width: 25% !important;
            }
            
            /* 隐藏展开箭头列 */
            .hidden-expand-column {
                width: 0 !important;
                padding: 0 !important;
                margin: 0 !important;
                border: none !important;
                overflow: hidden !important;
                
                .cell {
                    display: none !important;
                }
            }
            
            /* 优化选择框列宽度 */
            .el-table-column--selection {
                width: 35px !important;
                min-width: 35px !important;
                padding-right: 0 !important;
                
                .cell {
                    padding-left: 10px !important;
                    padding-right: 0 !important;
                }
            }
            
            /* 隐藏表头中的展开箭头列 */
            .el-table__header-wrapper .el-table__header th.hidden-expand-column {
                padding: 0 !important;
                width: 0 !important;
                min-width: 0 !important;
                border: none !important;
                overflow: hidden !important;
            }
            
            /* 彻底隐藏展开箭头 */
            .el-table__expand-icon {
                display: none !important;
            }
            
            /* 隐藏证书号列前面的展开图标 */
            .el-table__row .el-table__cell:first-child .cell i.el-icon,
            .el-table__row .el-table__cell:nth-child(2) .cell i.el-icon {
                display: none !important;
            }
            
            .el-table__header-wrapper {
                .el-table__header {
                    th {
                        background-color: #f2f2f2 !important;
                        border-bottom: 1px solid #ddd !important;
                        padding: 8px 0 !important;
                    }
                }
            }
            
            .el-table__body-wrapper {
                td {
                    padding: 5px 0 !important;
                    font-size: 12px !important;
                }
            }
            
            .el-table__row {
                &:nth-child(even) {
                    background-color: rgba(240, 240, 240, 0.5) !important;
                }
            }
            
            /* 展开行样式 */
            .el-table__expanded-cell {
                padding: 10px !important;
                background-color: #fafafa !important;
                
                .demo-table-expand {
                    font-size: 12px !important;
                    
                    .el-form-item {
                        margin-right: 10px !important;
                        margin-bottom: 0 !important;
                        
                        .el-form-item__label {
                            color: #606266 !important;
                        }
                    }
                }
            }
        }
        
        /* 结果卡片样式 */
        .result-card {
            margin-bottom: 10px;
            
            .el-card__body {
                padding: 10px;
            }
            
            .text {
                margin-bottom: 5px;
                
                span {
                    font-size: 14px !important;
                    line-height: 1.5;
                    display: block;
                    float: none !important;
                    margin-top: 5px;
                }
            }
            
            .el-button {
                margin-right: 5px;
                margin-bottom: 5px;
            }
        }
        
        /* 表格卡片样式 */
        .table-card {
            .el-card__body {
                padding: 10px;
            }
        }
        
        .mainds {
            position: relative;
            float: left;
            height: 500px;
        }
        .mainds {
            font-size: 12px;
            font-weight: bold;
            color: #04375f;
            -webkit-transform-origin-x: 0; // 文字居左
            -webkit-transform: scale(0.71);
            transform: scale(0.71);
            transform-origin: left top;
        }
        /* 表格行颜色样式 */
        .el-table {
            /* 奇数行颜色 */
            .el-table__row--striped td {
                background-color: #eaf3fb !important;
            }
            
            /* 偶数行颜色 */
            .el-table__row:not(.el-table__row--striped) td {
                background-color: #f5f7fa !important;
            }
            
            /* 鼠标悬停效果 */
            .el-table__row:hover td {
                background-color: #e6f1fc !important;
            }
            
            /* 表头固定样式 */
            .el-table__header-wrapper {
                .el-table__header {
                    th {
                        background-color: #f0f0f0 !important;
                        color: #333 !important;
                        font-weight: bold !important;
                        border-bottom: 2px solid #ddd !important;
                    }
                }
            }
            
            /* 滚动条样式 */
            .el-table__body-wrapper::-webkit-scrollbar {
                width: 6px;
                height: 6px;
            }
            
            .el-table__body-wrapper::-webkit-scrollbar-thumb {
                background-color: #c0c4cc;
                border-radius: 3px;
            }
            
            .el-table__body-wrapper::-webkit-scrollbar-track {
                background-color: #f5f5f5;
            }
            
            /* 单元格边框和内容对齐 */
            td {
                border-color: #ebeef5 !important;
                padding: 4px 0 !important;
            }
            
            /* 表格边框 */
            border: 1px solid #ebeef5 !important;
            border-radius: 4px;
            overflow: hidden;
        }
    }

    /* 移动端查询界面样式 - 已使用新的布局样式，移除旧样式 */

    /* 形状选择样式 */
    .shape-content {
        justify-content: space-between;
    }

    .shape-item {
        width: 50px;
        height: 50px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        border: 1px solid #ddd;
        border-radius: 4px;
        cursor: pointer;
        margin-bottom: 5px;
        padding: 2px 1px 0;
    }

    .shape-item.active {
        background-color: #e6f1fc;
        border-color: #4285f4;
    }

    .shape-icon {
        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
    }

    .shape-name {
        font-size: 12px;
        text-align: center;
        margin-top: auto;
        margin-bottom: 0;
    }

    .el-icon-round, .el-icon-princess, .el-icon-radiant,
    .el-icon-asscher, .el-icon-marquise, .el-icon-oval,
    .el-icon-emerald, .el-icon-pear1, .el-icon-heart,
    .el-icon-cushion, .el-icon-others, .el-icon-triangle {
        background-size: 30px 30px;
        width: 30px;
        height: 30px;
        margin: 0;
    }

    /* 克拉选择样式 */
    .carat-range {
        display: flex;
        flex-wrap: wrap;
        gap: 5px;
        margin-bottom: 10px;
        width: 100%;
    }

    .carat-item {
        padding: 5px 8px;
        border: 1px solid #ddd;
        border-radius: 4px;
        cursor: pointer;
        text-align: center;
        flex: 1;
        min-width: 40px;
    }

    .carat-item.active {
        background-color: #e6f1fc;
        border-color: #4285f4;
        color: #4285f4;
    }

    .carat-custom {
        display: flex;
        align-items: center;
        gap: 5px;
        width: 100%;
    }

    .carat-input {
        max-width: 80px;
    }

    .separator {
        margin: 0 5px;
    }

    /* 颜色、净度、切工等共用样式 */
    .color-item, .clarity-item, .cut-item, .polish-item, .symmetry-item, .fluorescence-item, .cert-item, .location-item, .other-item, .quick-item {
        padding: 5px 10px;
        border: 1px solid #ddd;
        border-radius: 4px;
        cursor: pointer;
        text-align: center;
        margin-right: 5px;
        margin-bottom: 5px;
    }

    .color-item.active, .clarity-item.active, .cut-item.active, .polish-item.active, .symmetry-item.active, .fluorescence-item.active, .cert-item.active, .location-item.active, .other-item.active, .quick-item.active {
        background-color: #e6f1fc;
        border-color: #4285f4;
        color: #4285f4;
    }

    /* 表单输入组样式 */
    .input-group {
        margin-bottom: 0; /* 移除底部间距 */
    }

    .input-label {
        margin-bottom: 5px;
        font-size: 14px;
    }

    /* 加点控制样式 */
    .point-control {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .point-value {
        width: 40px;
        text-align: center;
        font-size: 16px;
    }

    /* 操作按钮样式 - 已在上面定义 */

    /* 复选框组样式 */
    .checkbox-group {
        display: flex;
        flex-wrap: wrap;
        gap: 15px;
        margin-top: 10px;
    }


    .el-dialog{
        display: flex;
        flex-direction: column;
        margin: 0 !important;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .el-dialog .el-dialog__body{
        flex: 1;
        overflow: auto;
    }
    .el-icon-round {
        background:url('../../assets/images/cut2/round.png') center no-repeat;
        background-size: 40px 40px;
        width: 45px;
        height: 45px;
        margin: -7px;
        border-radius: 1px;
    }
    .el-icon-princess {
        background:url('../../assets/images/cut2/princess.png') center no-repeat;
        background-size: 40px 40px;
        width: 45px;
        height: 45px;
        margin: -7px;
        border-radius: 1px;
    }
    .el-icon-radiant {
        background:url('../../assets/images/cut2/radiant.png') center no-repeat;
        background-size: 40px 40px;
        width: 45px;
        height: 45px;
        margin: -7px;
        border-radius: 1px;
    }
    .el-icon-asscher {
        background:url('../../assets/images/cut2/asscher.png') center no-repeat;
        background-size: 40px 40px;
        width: 45px;
        height: 45px;
        margin: -7px;
        border-radius: 1px;
    }
    .el-icon-marquise {
        background:url('../../assets/images/cut2/marquise.png') center no-repeat;
        background-size: 40px 40px;
        width: 45px;
        height: 45px;
        margin: -7px;
        border-radius: 1px;
    }
    .el-icon-oval {
        background:url('../../assets/images/cut2/oval.png') center no-repeat;
        background-size: 40px 40px;
        width: 45px;
        height: 45px;
        margin: -7px;
        border-radius: 1px;
    }
    .el-icon-emerald {
        background:url('../../assets/images/cut2/emerald.png') center no-repeat;
        background-size: 40px 40px;
        width: 45px;
        height: 45px;
        margin: -7px;
        border-radius: 1px;
    }
    .el-icon-pear1 {
        background:url('../../assets/images/cut2/pear1.png') center no-repeat;
        background-size: 40px 40px;
        width: 45px;
        height: 45px;
        margin: -7px;
        border-radius: 1px;
    }
    .el-icon-heart {
        background:url('../../assets/images/cut2/heart.png') center no-repeat;
        background-size: 40px 40px;
        width: 45px;
        height: 45px;
        margin: -7px;
        border-radius: 1px;
    }
    .el-icon-cushion {
        background:url('../../assets/images/cut2/cushion.png') center no-repeat;
        background-size: 40px 40px;
        width: 45px;
        height: 45px;
        margin: -7px;
        border-radius: 1px;
    }
    .el-icon-others {
        background:url('../../assets/images/cut2/others.png') center no-repeat;
        background-size: 40px 40px;
        width: 45px;
        height: 45px;
        margin: -7px;
        border-radius: 1px;
    }
    .el-icon-triangle {
        background:url('../../assets/images/cut2/triangle.png') center no-repeat;
        background-size: 40px 40px;
        width: 45px;
        height: 45px;
        margin: -7px;
        border-radius: 1px;
    }
    /* 修改分页组件样式 */
    @media screen and (max-width: 748px) {
        .block.tar.mar_t {
            width: 100%;
            display: flex;
            justify-content: center;
            padding: 10px 0;

            .el-pagination {
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                gap: 5px;
                padding: 5px;
                white-space: normal;
                width: 100%;
                
                /* 总数和每页条数 */
                .el-pagination__total,
                .el-pagination__sizes {
                    height: 28px;
                    margin: 0 15px;
                }
                
                /* 页码按钮组 */
                .el-pager {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: center;
                    margin: 0;
                    
                    li {
                        min-width: 28px;
                        height: 28px;
                        line-height: 28px;
                        margin: 0 2px;
                        
                        &.active {
                            background-color: #409EFF;
                            color: #fff;
                        }
                    }
                }
                
                /* 上一页下一页按钮 */
                .btn-prev,
                .btn-next {
                    min-width: 28px;
                    height: 28px;
                    line-height: 28px;
                    padding: 0;
                    margin: 0 2px;
                }
                
                /* 跳转页输入框 */
                .el-pagination__jump {
                    margin: 0 5px;
                    height: 28px;
                    line-height: 28px;
                    
                    .el-input {
                        width: 50px;
                        margin: 0 5px;
                        
                        input {
                            height: 28px;
                            line-height: 28px;
                            text-align: center;
                        }
                    }
                }

                /* 特小屏幕适配 */
                @media screen and (max-width: 375px) {
                    .el-pagination__sizes {
                        display: none; // 隐藏每页条数选择器
                    }
                    
                    .el-pagination__jump {
                        margin: 5px 0;
                    }
                }
            }
        }
    }

    .diamond-mobile-table {
        width: 100%;
        margin: 0;
        padding: 0;
        
        /* 隐藏展开箭头 */
        .el-table__expand-icon {
            display: none;
        }
        
        /* 内容紧凑化 */
        .el-table__cell {
            padding: 2px 0 !important;
        }
        
        /* 表头样式优化 */
        .el-table__header-wrapper th {
            background-color: #f8f8f8 !important;
            padding: 5px 0 !important;
        }
        
        /* 选中行样式 */
        .el-table__row.current-row {
            background-color: #f0f7ff !important;
        }
        
        /* 奇偶行样式 */
        .el-table__row:nth-child(odd) {
            background-color: #fff;
        }
        
        .el-table__row:nth-child(even) {
            background-color: #fafafa;
        }
        
        /* 点击时的高亮效果 */
        .el-table__row:active {
            background-color: #e6f1fc;
        }
        
        /* 价格区域样式 */
        .price-area {
            display: flex;
            flex-direction: column;
            align-items: center;
        }
    }

    .media-links {
        display: flex;
        justify-content: center;
        gap: 10px;
        margin-top: 3px;
    }
    
    .image-link, .vedio_link {
        cursor: pointer;
        
        i {
            color: #409EFF;
            font-size: 14px;
            &:hover {
                color: #66b1ff;
            }
        }
    }
    
    .vedio_link .el-icon-video-camera {
        color: #F56C6C;
        &:hover {
            color: #f78989;
        }
    }

    .image-dialog-content {
        display: flex;
        justify-content: center;
        align-items: center;
        
        .diamond-image {
            max-width: 100%;
            max-height: 70vh; // 限制高度为视口高度的70%
            object-fit: contain;
        }
    }
    
    .video-dialog-content {
        display: flex;
        justify-content: center;
        align-items: center;
        
        .diamond-video {
            max-width: 100%;
            max-height: 70vh; // 限制高度为视口高度的70%
            object-fit: contain;
        }
    }

    // 调整对话框样式
    .el-dialog__header {
        padding: 15px 20px 10px;
        text-align: center;
        border-bottom: 1px solid #ebeef5;
    }

    .el-dialog__body {
        padding: 15px;
    }

    // 适配移动端样式
    @media screen and (max-width: 748px) {
        .el-dialog {
            width: 95% !important;
            margin-top: 20vh !important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/phone/shoppingMobile.vue